module.exports = __webpack_public_path__ + "static/media/icon-supplies-contacts.751be775.svg";